import React from 'react';

//Material
import CloseIcon from '@mui/icons-material/Close';

import { Box, Grid, Modal, Typography } from '@mui/material';

import { StyledLabel } from '../../components/StyledComponents';
import { connect, useDispatch } from 'react-redux';
import { LetsGoBtn } from '../../components/Buttons';
import { setIsOpenParcelDoneModal } from '../../redux/mainReducer';

import './DeleteModal.css';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: { xs: 390, sm: 650 },
  minWidth: 390,

  bgcolor: 'background.paper',
  borderRadius: '20px',
  border: 'none',
  boxShadow: 24,
  padding: { xs: '20px ', md: '50px 60px 50px 60px' },
  overflow: 'scroll',
  height: 'inherit',
  maxHeight: '100vh',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none'
  }
};

function ParcelDoneModal({ isOpenModal, func, serviceName, seller }) {
  const dispatch = useDispatch();

  return (
    <div>
      <Modal
        open={isOpenModal}
        onClose={(event, reason) => {
          if (reason === 'backdropClick') {
            return;
          }

          dispatch(
            setIsOpenParcelDoneModal({ isOpen: false, serviceName: '', seller: '', func: null })
          );
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="bonfair_delete_modal"
      >
        <Box sx={style} className="bonfair_delete_modal-box">
          <CloseIcon
            className="bonfair_delete_modal-close"
            style={{ position: 'absolute', right: '10px', top: '10px', cursor: 'pointer' }}
            onClick={() => {
              dispatch(
                setIsOpenParcelDoneModal({ isOpen: false, serviceName: '', seller: '', func: null })
              );
            }}
          />

          <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
              <StyledLabel className="deleteModal-title-text">
                {/* {translate('bonfair_service_modal')} */}
                {'Підтвердження отримання'}
              </StyledLabel>
            </Grid>
            <Grid item xs={12} md={12} lg={12} sx={{ display: 'flex', justifyContent: 'center' }}>
              <Typography
                variant="subtitle2"
                sx={{
                  mb: 2,
                  fontSize: 16,
                  fontFamily: 'FixelText-Regular',
                  fontWeight: '400',
                  textAlign: 'center',
                  maxWidth: '70%'
                }}
              >
                {`Ви підтверджуєте отримання товару “${serviceName}” від ${seller}?`}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                margin: '20px auto 0px',
                maxWidth: '350px',
                flexDirection: { xs: 'column', sm: 'row', md: 'row', lg: 'row' },
                gap: '10px'
              }}
            >
              <LetsGoBtn
                colorScheme="blue"
                size="large"
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  func('DONE');
                  dispatch(
                    setIsOpenParcelDoneModal({
                      isOpen: false,
                      serviceName: '',
                      seller: '',
                      func: null
                    })
                  );
                }}
                width={'100%'}
                style={{ textTransform: 'inherit' }}
                text="Товар отримано"
              />
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale
  };
};
export default connect(mapStateToProps)(ParcelDoneModal);
